import React from 'react';

/**
 * The "Admin Portal / Dental Clinic" title block, shared between the desktop
 * sidebar header and the phone nav drawer header (Ruling R10). Callers supply
 * their own wrapping element so each keeps its own layout class.
 */
const SidebarBrand = () => (
  <>
    <div className="sidebar-logo">Admin Portal</div>
    <div className="sidebar-subtitle">Dental Clinic</div>
  </>
);

export default SidebarBrand;
